import { connect } from 'react-redux';

import  { selectors } from '@amplement/backend-connector';
import { getStatusById } from 'selectors/presence';

import UnicastFeeds from './index';

const mapStateToProps = (state, { id }) => {
    const feed = selectors.feeds.feedByIdSelector(state, id);
    const { unreadCount, user, _anchor } = feed || {};
    const { firstname, lastname, avatar, avatarUri } = user || {};

    return ({
        firstname,
        lastname,
        avatarUri: avatarUri || avatar?.file?.uri,
        unreadCount,
        status: user?.id ? getStatusById(state, user.id) : undefined,
        _anchor
    });
};

export default connect(mapStateToProps, null)(UnicastFeeds);
